import { getFilteredOptions } from "helpers";
import { WithholdStatuses } from "types";

const loadOptions = async search => {
	let options = await WithholdStatuses.getOptions();

	const filteredOptions = getFilteredOptions(search, options);

	return {
		options: filteredOptions,
		hasMore: false,
	};
};

const agentWithholdReasonColumn = () => ({
	name: "agentWithholdReason",
	type: "select" as const,
	loadOptions,
	getOptionLabel: option => option.displayName,
	getOptionValue: option => option.value,
	placeholder: "Agent Withhold Reason",
});

export default agentWithholdReasonColumn;
